import { createFileRoute, useCanGoBack, useNavigate, useRouter } from "@tanstack/react-router"
import { useCallback } from "react"
import z from "zod"

import { BrowserPermissions } from "@/components/permissions/BrowserPermissions"
import { logger } from "@/utils/logging"

export const Route = createFileRoute("/$sessionId/_session/permissionsGuide")({
  component: PermissionsGuideRoute,
  validateSearch: z.object({
    navigateBackOnDone: z.boolean().optional(),
  }),
})

function PermissionsGuideRoute() {
  const { sessionId } = Route.useParams()
  const { navigateBackOnDone } = Route.useSearch()
  const { history } = useRouter()
  const canGoBack = useCanGoBack()
  const navigate = useNavigate()

  const onDoneCb = useCallback(() => {
    // When the page is opened directly via a shared link, there is no history to go
    // back to. Fallback to the session root which redirects to the first unfinished step.
    if (canGoBack) {
      logger.debug("[permissionsGuide] onDoneCb: canGoBack=true → history.back()")
      history.back()
    } else {
      logger.debug("[permissionsGuide] onDoneCb: canGoBack=false → navigate to /$sessionId")
      navigate({ to: "/$sessionId", params: { sessionId }, replace: true })
    }
  }, [canGoBack, history, navigate, sessionId])

  return <BrowserPermissions onDoneCb={navigateBackOnDone ? onDoneCb : undefined} />
}
